import { render } from "./AppTag.vue?vue&type=template&id=413e9c36"
import script from "./AppTag.vue?vue&type=script&lang=js"
export * from "./AppTag.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__